<template lang="pug">
    div(class="background-page-bengkulu login-bengkulu ")
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg5 md5 xs12 hidden-xs-only class="mt-6")
                    v-card(class="card-login" elevation="6" v-if="items && items.length > 0")
                        v-card-text
                            v-carousel(height="250px" :show-arrows="false" cycle)
                                v-carousel-item(v-for="(item,i) in items" :key="i")
                                    f-banner-image-content(:value="item")
                    v-layout(wrap)
                        v-flex(lg4 md4 xs12 class="mt-4")
                            div(class="lock-logo")
                        v-flex(lg6 md6 xs12 text-center justify-center class="mt-2")
                            v-btn(class="caption font-weight-bold primary--text" text @click="routeToInfoMenu('SECURITY_BANKING')") 
                                v-icon(small left color="primary") mdi-shield-account
                                span Tips Keamanan Bertransaksi
                            v-btn(class="caption font-weight-bold primary--text" text @click="routeToInfoMenu('SECURITY_PRIVACY')")
                                v-icon(small left color="primary") mdi-shield-half-full
                                span Kebijakan Privacy dan Keamanan
                            v-btn(class="caption font-weight-bold primary--text" text @click="routeToInfoMenu('SECURITY_FAQ')") 
                                v-icon(small left color="primary") mdi-help-circle-outline
                                span Frequently Asked Questions
                v-flex(lg3 md3 xs12 hidden-sm-only hidden-xs-only class="mt-6")
                    v-card(class="card-login")
                        v-card-text
                            div(class="subtitle-2 font-weight-bold primary--text mt-3") {{prop.name}}
                            v-divider              
                            div(row wrap)
                                div(class="caption font-weight-bold") Layanan ini digunakan untuk mempermudah transaksi keuangan untuk instansi / korporasi
                            
                            div(class="subtitle-2 font-weight-bold primary--text mt-3") Info Penting
                            v-divider              
                            div(row wrap)
                                div(class="caption font-weight-bold")  Jaga kerahasiaan User ID, Password, Alamat Email dan Token Anda.
                                    div(class="caption font-weight-bold black--text mt-2")  Jangan beritahu kepada pihak lain termasuk staf Bank Bengkulu.
                                div(class="caption font-weight-bold mt-2")  Jika terjadi HAL YANG TIDAK WAJAR / BIASA, Hentikan Transaksi dan segera konfirmasi ke Bank Bengkulu
                            div(class="subtitle-2 font-weight-bold primary--text mt-3") Kontak Kami
                            v-divider              
                            div(row wrap)
                                div(class="subtitle-2 font-weight-bold mt-2") Bank Bengkulu Call : 1500133
                                v-layout(wrap class="mt-1")
                                    v-icon(size="18px" color="indigo" ) mdi-web
                                    a(:href="prop.websiteInfo.linkWebsite" target="_blank" style="color:#757474; text-decoration:none; margin-left:5px" class="caption font-weight-bold black--text") {{ prop.websiteInfo.website }}
                            div(class="ojk-logo")
                            div(class="caption font-weight-bold primary--text" style="text-align:center;") {{prop.version}}
                v-flex(lg4 md4 xs12 class="mt-6")
                    v-card(class="card-login" max-height="570" elevation="6")
                        v-card-text
                            div(class="login-logo")
                            v-layout(wrap justify-center align="center")
                                div(class="title font-weight-bold secondary--text ml-2" ) {{prop.name}}
                            v-flex(v-if="message" style="text-align:center" class="error--text") {{message}}
                            v-form(ref="form" id="form" @submit.prevent="validateLogin" autocomplete="off")
                                v-container
                                    v-layout(row wrap)
                                        v-flex
                                            div(v-if="prop.simplecaptcha")
                                                v-layout(wrap class="mt-2")
                                                    v-flex(lg5 md5 xs12)
                                                        v-text-field(dense v-model="captcha" label="Captcha" :rules="[v => !!v || 'Masukan captcha']" required prepend-icon="mdi-shield-half-full")
                                                    v-flex(lg6 md6 xs12)
                                                        v-row
                                                            v-img(v-bind:src="'data:image/png;base64,' +image" height="50" width="150")
                                                            v-icon(color="primary" @click="getSimpleCaptcha") mdi-refresh
                                            v-text-field(v-model="login.username" :rules="[v => !!v || 'Masukan username']"
                                                label="Username" prepend-icon="mdi-account-circle" required)
                                            f-passwordbox(v-model="login.password" :rules="[v => !!v || 'Masukan password']" label="Password" :required="true" )
                                            div(class="justify-center mt-2")
                                                v-btn(color="btnprimary" class="white--text" type="submit" form="form" style="width:100%" :disabled="loading" :loading="loading") Masuk
                                            div(class="justify-end text-right mt-2")
                                                v-btn(class="caption font-weight-bold primary--text" text @click="routeToMenu('reset-pass')")
                                                    v-icon(small left color="primary") mdi-help-circle-outline
                                                    span Lupa Password
                                            div(class="mt-2")
                                                v-row(class="caption font-weight-bold justify-center text-center")
                                                    div Dengan Menekan Tombol 
                                                    strong(class="mx-1") Login 
                                                    div User Menyetujui
                                                    span(style="cursor:pointer" class="primary--text" @click="routeToInfoMenu('SECURITY_TERM')") Syarat & Ketentuan, (Term & Condition) 
                                                    div(class="mx-1") yang berlaku.
                                            
</template> 
<script>
import localforage from "localforage";
import config from "../../../config";
export default {
    name: 'FLoginBengkulu',
    data() {
        return {
            message: "",
            prop: config,
            login: {
                username: "",
                password: ""
            },
            items: [],
            loading: false,
            image: null,
            captcha: null,
            audit: {
                longitude: null,
                latitude: null,
                userAgent: null
            }
        }
    },
    mounted() {
        this.setAudit();
        this.getBanner();
        if (this.prop.simplecaptcha) {
            this.getSimpleCaptcha();
        }
    },
    methods: {
        setAudit() {
            if (this.prop.geo) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this.audit.latitude = position.coords.latitude;
                        this.audit.longitude = position.coords.longitude;
                    }, error => {
                        this.audit.latitude = null;
                        this.audit.longitude = null;
                    },
                );
                this.audit.userAgent = navigator.userAgent;
            } else {
                this.audit.latitude = "Not Secured Connection";
                this.audit.longitude = "Not Secured Connection";
                this.audit.userAgent = "Not Secured Connection";
            }
        },
        doLogin(){
            if (this.$refs.form.validate()) {
                if (this.audit.longitude && this.audit.latitude) {
                    this.loading = true;
                    this.$session.clear();
                    window.$cookies.set("longitudeIbk", this.audit.longitude);
                    window.$cookies.set("latitudeIbk", this.audit.latitude);
                    window.$cookies.set("userAgentIbk", this.audit.userAgent);
                    this.$http.post("/api/sec/login", {
                        granType: "password",
                        username: this.login.username,
                        password: this.login.password
                    }).then(success => {
                        const data = success.data;
                        const accessToken = data.access_token;
                        const refresh_token = data.refresh_token;
                        var userDetails = data.userDetails; 
                        var timeout = (userDetails.idleTimeout ? userDetails.idleTimeout : 5) + 1;
                        window.$cookies.set("access_token_ibk", accessToken, timeout + "min");
                        window.$cookies.set("refresh_token_ibk", refresh_token, timeout + "min");
                        window.$cookies.set("idleTimeoutIbk", timeout, timeout + "min");
                        localforage.setItem("userDetailIbk", userDetails);

                        this.$router.push({ name: "menu" }).catch(err => {});
                    }, err => {
                        this.resetCaptcha();
                        let cause = err.response.data.cause;
                        let message = err.response.data.message;
                        this.message = message ? message : cause ? cause : err;
                    }).finally(() => (this.loading = false));
                } else {
                    this.message = "Aktifkan lokasi";
                }
            }
        },
        resetCaptcha(){
          if (this.prop.simplecaptcha) {
            this.getSimpleCaptcha();
            this.captcha = null;
            if (this.$refs.form) {
              this.$refs.form.resetValidation();
            }

          }
        },
        getBanner(){
            this.$http.get("/api/util/banner").then(success => {
                this.items = success.data;
            });
        },
        getSimpleCaptcha(){
            this.$http.get("/api/util/captcha", {
                params: {
                    color: '#01662c',
                    height: 48,
                    width: 195
                }
            }).then(success => {
                this.image = success.data;
            });
        },
        validateCaptcha(){
            if (this.$refs.form.validate()) {
                this.$http.get("/api/util/captcha-validate", {
                    params: {
                        captcha: this.captcha
                    }
                }).then(success => {
                    this.doLogin()
                }, err => {
                    this.message = err.response.data.message;
                    this.getSimpleCaptcha();
                });
            }
        },
        validateLogin(){
            if (this.prop.simplecaptcha) {
                this.validateCaptcha()
            } else {
                this.doLogin();
            }
        },
        routeToMenu(code){
            this.$router.push({ name: code }).catch(err => {});
        },
        routeToInfoMenu(code){
            this.$router.push({ 
                name: "info",
                params: { code: code }
             }).catch(err => {});
        }
    },
}
</script>

<style src="../../../assets/style/bengkulu/login-bkl.css"/>